import localStorageService from '@/core/local-storage'

export default {
  state: {
    files: localStorageService.getItem('files') || {}
  },

  mutations: {
    setFile (state, value) {
      const files = JSON.parse(JSON.stringify(state.files))

      files[value.id] = {
        percent: value.percent,
        bookId: value.bookId,
        abort: value.abort
      }

      state.files = files
      localStorageService.setItem('files', files)
    },

    deleteFile (state, id) {
      const files = JSON.parse(JSON.stringify(state.files))

      delete files[id]

      state.files = files
      localStorageService.setItem('files', files)
    }
  }
}
